import React from "react"

import { IncidentListItem, ArchivedIncidentItem } from "./utils/form-field-mapping"
import { Form as FormStructure } from "./models/new/forms.types"
import Issue from "./models/issue"

interface IIncidentContext {
  incidents: undefined | IncidentListItem[]
  setIncidents: React.Dispatch<React.SetStateAction<undefined | IncidentListItem[]>>

  archivedIncidents: undefined | ArchivedIncidentItem[]
  setArchivedIncidents: React.Dispatch<React.SetStateAction<undefined | ArchivedIncidentItem[]>>
}

interface IInspectionContext {
  inspectionForms: undefined | FormStructure[]
  setInspectionForms: React.Dispatch<React.SetStateAction<undefined | FormStructure[]>>
}

interface IIssueContext {
  issues: undefined | Issue[]
  setIssues: React.Dispatch<React.SetStateAction<undefined | Issue[]>>

  archivedIssues: undefined | Issue[]
  setArchivedIssues: React.Dispatch<React.SetStateAction<undefined | Issue[]>>

  issueForms: undefined | FormStructure[]
  setIssueForms: React.Dispatch<React.SetStateAction<undefined | FormStructure[]>>
}

// @ts-ignore
export const IncidentContext = React.createContext<IIncidentContext>()

// @ts-ignore
export const InspectionContext = React.createContext<IInspectionContext>()

// @ts-ignore
export const IssueContext = React.createContext<IIssueContext>()
